/*
 * Mention « Expédition : groupée » sous les articles d'un panier mixte
 * ---------------------------------------------------------------------
 * Quand les articles du panier n'ont pas tous la même « Estimation de
 * livraison » (ex. un article en stock + un article en rupture), ce script
 * ajoute une seconde ligne sous chaque article :
 *     Expédition : en un seul colis, à la date de l'article le plus tardif
 * Cette ligne suit l'article au paiement, dans la commande et dans l'admin.
 * Dès que le panier n'est plus mixte, la ligne est retirée.
 *
 * Installation : voir les instructions fournies avec ce fichier.
 */
(function () {
  'use strict';

  // ---- Réglages -----------------------------------------------------------
  // Libellé exact utilisé par l'application Delivery Date - ETA.
  var ETA_KEY = 'Estimation de livraison';
  // Libellé et texte de la mention ajoutée.
  var NOTE_KEY = 'Expédition';
  var NOTE_VALUE = "en un seul colis, à la date de l'article le plus tardif";
  // -------------------------------------------------------------------------

  if (!window.fetch) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var syncing = false;
  var pending = false;
  var timer = null;

  function norm(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  // Valeur de l'estimation de livraison d'une ligne (null si absente).
  function getEta(item) {
    var props = item.properties || {};
    for (var key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key) && norm(key) === norm(ETA_KEY)) {
        var value = norm(props[key]);
        return value === '' ? null : value;
      }
    }
    return null;
  }

  // Panier mixte = au moins deux estimations de livraison différentes.
  function isMixed(cart) {
    var seen = {};
    var count = 0;
    (cart.items || []).forEach(function (item) {
      var eta = getEta(item);
      if (eta !== null && !seen[eta]) {
        seen[eta] = true;
        count++;
      }
    });
    return count > 1;
  }

  function isBlank(value) {
    return value == null || String(value).trim() === '';
  }

  // Première ligne dont la mention n'est pas dans l'état voulu.
  function nextFix(cart) {
    var mixed = isMixed(cart);
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};
      var ok = mixed ? props[NOTE_KEY] === NOTE_VALUE : isBlank(props[NOTE_KEY]);
      if (!ok) {
        var next = {};
        for (var key in props) {
          if (Object.prototype.hasOwnProperty.call(props, key) && key !== NOTE_KEY) {
            next[key] = props[key];
          }
        }
        // Les propriétés d'une ligne sont remplacées en bloc : omettre la clé la retire.
        if (mixed) next[NOTE_KEY] = NOTE_VALUE;
        return { index: i, item: items[i], properties: next };
      }
    }
    return null;
  }

  function getCart() {
    return nativeFetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function changeLine(fix) {
    return nativeFetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: fix.item.key,
        quantity: fix.item.quantity,
        properties: fix.properties
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/change ' + response.status);
      return response.json();
    });
  }

  // Corrige les lignes une par une (les clés de ligne changent à chaque modification).
  // S'arrête si une correction n'a pas d'effet, pour ne jamais boucler.
  function fixAll(cart, remaining, changed) {
    var fix = nextFix(cart);
    if (!fix || remaining <= 0) return Promise.resolve(changed);
    return changeLine(fix).then(function (updatedCart) {
      var again = nextFix(updatedCart);
      var stuck =
        again &&
        again.index === fix.index &&
        (updatedCart.items || []).length === (cart.items || []).length;
      if (stuck) return changed;
      return fixAll(updatedCart, remaining - 1, true);
    });
  }

  // Réaffiche le panier pour que la mention apparaisse sans attendre.
  function refreshUi() {
    if (document.getElementById('main-cart-items')) {
      // Garde-fou : jamais deux rechargements à moins de 10 secondes d'intervalle.
      try {
        var last = Number(sessionStorage.getItem('vbpExpeditionReload') || 0);
        if (Date.now() - last < 10000) return;
        sessionStorage.setItem('vbpExpeditionReload', String(Date.now()));
      } catch (error) {
        return;
      }
      window.location.reload();
      return;
    }
    if (!document.querySelector('cart-drawer')) return;
    nativeFetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['.cart-drawer__items', '.cart-drawer__footer--subtotal'].forEach(function (selector) {
          var source = doc.querySelector(selector);
          var target = document.querySelector('cart-drawer ' + selector);
          if (source && target) target.innerHTML = source.innerHTML;
        });
      })
      .catch(function () {});
  }

  function sync() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;
    getCart()
      .then(function (cart) {
        var max = ((cart.items || []).length + 1) * 2;
        return fixAll(cart, max, false);
      })
      .then(function (changed) {
        if (changed) refreshUi();
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // Relance la vérification après chaque modification du panier faite par le thème.
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        promise.then(schedule, function () {});
      }
    } catch (error) {}
    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
